// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.avatar[data-v-5811d9ee] {\n    border: 5px solid white;\n    -webkit-box-shadow: 0 0 0 1px lightgrey;\n            box-shadow: 0 0 0 1px lightgrey;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
